import axios from "axios";
import api, { BASE_API_URL } from "./api";

const login = async (email, password, customerKey) => {
  const response = await api.post("/admins/login", {
    email,
    password,
    customerKey,
  });
  return response.data;
};

const getMyDetails = async () => {
  const response = await api.get("/admins/me");
  return response.data;
};

const getAuthToken = async (refreshToken, config = {}) => {
  return axios.post(
    `${BASE_API_URL}/admins/refresh-token`,
    { refreshToken },
    config
  );
};

const requestPasswordReset = async (email, customerKey) => {
  const response = await api.post("/admins/request-password-reset", {
    email,
    customerKey,
  });
  return response.data;
};

// Initial Setup
const completeInitialSetup = async (setupData) => {
  const response = await api.post("/admins/complete-setup", setupData);
  return response.data;
};

const getSystemInitStatus = async () => {
  const response = await api.get("/admins/system-status");
  return response.data;
};

const authService = {
  login,
  getAuthToken,
  requestPasswordReset,
  getMyDetails,
};

export default authService;
